import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { AppPage } from 'app/common/app-page/features/app-page';
import * as PageNotifications from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/railways/router/routes';
import { PageContent } from 'app/ui';

import { UserDetails } from './user-details';

export const DetailUserPage = observer(() => {
  const { id } = useTypedParams(appRoute.USER.DETAILS);

  return (
    <AppPage perm="PERM_USER_READ">
      <PageContent>
        <PageNotifications.Provider>
          <UserDetails id={Number(id)} />
        </PageNotifications.Provider>
      </PageContent>
    </AppPage>
  );
});
